export default "__VITE_ASSET__807c3221__"